import gql from 'graphql-tag';

import { FULL_PLEX_FRAGMENT } from '../fragments/Plex/fullPlex';
import { FULL_PLEX_INPUT_ERROR_FRAGMENT } from '../fragments/PlexInputError/fullPlexInputError';

export const CREATE_PLEX_MUTATION = gql`
  mutation CreatePlex($plex: PlexInput!) {
    createPlex(plex: $plex) {
      ...fullPlex
      ...fullPlexInputError
    }
  }

  ${FULL_PLEX_FRAGMENT}
  ${FULL_PLEX_INPUT_ERROR_FRAGMENT}
`;

export { useCreatePlexMutation } from '../gen/types';
